import { PermissionTypes } from "../actions/actios.types";

interface PermissionState {
  permissions: any[] | null;
}

const initialState: PermissionState = {
  permissions: [],
};

const permissionReducer = (
  state = initialState,
  action: any,
): PermissionState => {
  switch (action.type) {
    case PermissionTypes.SET_PERMISSION:
      return {
        ...state,
        permissions: action.payload,
      };
    default:
      return state;
  }
};
export default permissionReducer;
